import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faShoppingBag, faStar } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp, faFacebookF } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
    const [tienda, setTienda] = useState([]);
    const api = baseURL;
    const [links, setLinks] = useState({ about_label:'Sobre Nosotros', about_url:'#', services_label:'Servicios', services_url:'#', faqs_label:'FAQs', faqs_url:'#', contact_label:'Contacto', contact_url:'#' });
    const [reviews, setReviews] = useState({ enabled:false, name:'', rating:null, count:null });
    //const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        cargarTienda();
        fetch(`${api}/footerConfigGet.php`, { method:'GET' })
          .then(r=>r.json()).then(d=>{ if(d && d.config) setLinks(d.config); }).catch(()=>{});
        fetch(`${api}/googleReviewsGet.php`).then(r=>r.text()).then(t=>{ try{ const j=JSON.parse(t); setReviews({ enabled: !!j.enabled, name: j.name||'', rating: j.rating||null, count: j.count||null }); }catch(_){ setReviews({ enabled:false }); } }).catch(()=>{ setReviews({ enabled:false }); });
    }, []);

    const cargarTienda = () => {
        fetch(`${api}/tiendaGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const d=JSON.parse(t); setTienda((d.tienda||[]).reverse()[0] || []); }catch(_){ setTienda([]);} })
            .catch(()=>{});
    };

    return (
        <div className='FooterContain'>
            <div className='footer-inner'>
                <div className='footer-top'>
                    <Anchor to={links.about_url || '#'}>{links.about_label || 'Sobre Nosotros'}</Anchor>
                    <Anchor to={links.services_url || '#'}>{links.services_label || 'Servicios'}</Anchor>
                    <Anchor to={links.faqs_url || '#'}>{links.faqs_label || 'FAQs'}</Anchor>
                    <Anchor to={links.contact_url || '#'}>{links.contact_label || 'Contacto'}</Anchor>
                </div>
                <div className='footer-main'>
                    <div className='footer-left'>
                        <div className='footer-brand'>
                            <Anchor to='/'>
                                {(() => {
                                  const useFallback = !tienda?.imagen1;
                                  const isTransparent = !useFallback && /\.(png|svg)$/i.test(String(tienda?.imagen1||''));
                                  const src = useFallback ? logo : ((tienda?.imagen1 && /^https?:/i.test(tienda.imagen1)) ? tienda.imagen1 : `${api}/${String(tienda?.imagen1||'').replace(/^\//,'')}`);
                                  const cls = isTransparent ? 'footer-logo transparent' : 'footer-logo circle';
                                  return (<img src={src} alt="logo" className={cls} width={40} height={40} loading='lazy' decoding='async' />);
                                })()}
                            </Anchor>
                            <div className='footer-name'>
                                {tienda?.nombre ? (<h2>{tienda?.nombre}</h2>) : (<h2>Mi Tienda</h2>)}
                                {tienda?.eslogan ? (<div className='subtitle'>{tienda?.eslogan}</div>) : null}
                                {reviews.enabled && reviews.rating && (
                                  <a href={links.about_url || '#'} className='rating-badge' title='Reputación en Google' target='_blank' rel='noreferrer'>
                                    <FontAwesomeIcon icon={faStar} />
                                    <span>{reviews.rating} ({reviews.count})</span>
                                  </a>
                                )}
                            </div>
                        </div>
                        <div className='contact-pill'>Contáctanos</div>
                        <div className='contact-lines'>
                            <div>Correo: {tienda?.email ? (<a href={`mailto:${tienda.email}`}>{tienda.email}</a>) : ''}</div>
                            <div>Teléfono: {(() => { const d = String(tienda?.telefono||'').replace(/\D+/g,''); return d ? (<a href={`https://wa.me/${d}`} target="_blank" rel='noreferrer'>{tienda?.telefono}</a>) : ''; })()}</div>
                            <div><a href={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion||'')}`} target="_blank" rel='noreferrer'>{tienda?.direccion || ''}</a></div>
                        </div>
                    </div>
                    <div className='quick-links'>
                        <Anchor to={links.about_url || '#'}>{links.about_label || 'Sobre Nosotros'}</Anchor>
                        <Anchor to={links.services_url || '#'}>{links.services_label || 'Servicios'}</Anchor>
                        <Anchor to={links.faqs_url || '#'}>{links.faqs_label || 'FAQs'}</Anchor>
                        <Anchor to={links.contact_url || '#'}>{links.contact_label || 'Contacto'}</Anchor>
                    </div>
                    <div className='footer-right'>
                        <div className='socials-label'>Redes Sociales:</div>
                        <div className='socials-round'>
                            {tienda.instagram && (
                              <a href={/^https?:/i.test(tienda.instagram)?tienda.instagram:`http://${tienda.instagram}`} target="_blank" rel='noreferrer' aria-label='Instagram'>
                                <FontAwesomeIcon icon={faInstagram} size='lg' />
                              </a>
                            )}
                            {tienda.telefono && ( (()=>{ const d=String(tienda.telefono||'').replace(/\D+/g,''); return (
                              <a href={`https://wa.me/${d}`} target="_blank" rel='noreferrer' aria-label='WhatsApp'>
                                <FontAwesomeIcon icon={faWhatsapp} size='lg' />
                              </a>
                            ); })() )}
                            {tienda.facebook && (
                              <a href={/^https?:/i.test(tienda.facebook)?tienda.facebook:`http://${tienda.facebook}`} target="_blank" rel='noreferrer' aria-label='Facebook'>
                                <FontAwesomeIcon icon={faFacebookF} size='lg' />
                              </a>
                            )}
                        </div>
                        <div className='footer-nav-link'>
                            <Anchor to={`/productos`}>
                                <FontAwesomeIcon icon={faShoppingBag} />
                                <span>Ver Todos los Productos</span>
                            </Anchor>
                        </div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <div className='copyright'>© {new Date().getFullYear()} — Derechos reservados</div>
                </div>
            </div>
        </div>
    );
}
